<template>
  <div class="recruitmentDetail_container">
    <el-card class="card">
      <div class="nav">
        <i class="el-icon-s-home"></i>
        首页 > {{ dataDetail.recruitType == 1 ? '校园招聘' : '社会招聘' }} >
        {{ dataDetail.position }}
      </div>
      <div class="title">{{ dataDetail.position }}</div>
      <div class="box">
        <template v-for="(v, k) in dataDetail">
          <div class="item" v-if="k in dic" :key="k">
            <span class="item_title">{{ dic[k] }}:</span>
            <span class="item_note">{{ v }}</span>
          </div>
        </template>
      </div>
      <div class="describle">
        <div class="describle_detail" v-html="dataDetail.jobDescription"></div>
      </div>
      <div class="turn_back">
        <el-button type="primary" round @click="goback">返回</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'recruitmentDetail',
  data() {
    return {
      eId: '',
      dataDetail: {
        workPlace: '',
        experience: '',
        education: '',
        jobType: '',
        count: '',
        createTime: '',
        recruitType: '',
        position: '', // 职位
        jobDescription: '', // 职位描述
      },
      dic: {
        workPlace: '工作地点',
        experience: '工作经验',
        education: '学历',
        jobType: '工作类型',
        count: '招聘人数',
        createTime: '发布时间',
      },
      // baseData: [
      //   { title: '工作地点', note: '' },
      //   { title: '工作经验', note: '' },
      //   { title: '学历', note: '' },
      //   { title: '工作类型', note: '' },
      //   { title: '招聘人数', note: '' },
      //   { title: '发布时间', note: '' },
      // ],
    };
  },
  created() {
    this.eId = this.$route.query.id;
    this.position = this.$route.query.position;
    this.recruitmentType = this.$route.query.recruitmentType;
    this.queryDetail();
  },
  methods: {
    //返回上一页
    goback() {
      this.$router.go(-1);
    },
    //获取职位详情
    queryDetail() {
      console.log(this.eId, 'eid');
      if (this.eId) {
        axios
          .post('/api/recruit/getById', {
            body: {
              id: this.eId,
            },
          })
          .then(res => {
            // console.log(res);
            this.dataDetail = res.data.body.recruit;
            // this.baseData[0].note =
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
  },
};
</script>
<style lang="scss">
.recruitmentDetail_container {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  .card {
    width: 840px;
    text-align: left;
    .nav {
      color: #999;
      font-size: 12px;
    }
    .title {
      font-size: 28px;
      margin: 30px 0 0 0;
      color: #333333;
    }
    .box {
      padding: 20px;
      margin-top: 30px;
      color: #000000;
      background: #f4f4f4;
      font-size: 14px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 33%;
        font-size: 14px;
        height: 24px;
        line-height: 24px;
        .item_title {
          color: #999;
          margin-right: 5px;
        }
      }
    }
    .describle {
      margin-top: 25px;
      .describle_title {
        color: #333;
        font-size: 18px;
      }
      .describle_detail {
        margin: 14px 0;
      }
    }
    .turn_back {
      display: flex;
      justify-content: center;
      .el-button {
        width: 170px;
      }
      .el-button--primary {
        color: #fff;
        background-color: #6f5014;
        border-color: #6f5014;
      }
      .el-button--primary.is-active,
      .el-button--primary:active {
        background: #6f5014;
        border-color: #6f5017;
        color: #fff;
      }
      .el-button--primary:focus,
      .el-button--primary:hover {
        background: #6f5014;
        border-color: #6f5014;
        opacity: 0.8;
        color: #fff;
      }
    }
  }
}
</style>
